import { reduxKey } from './constants';
import { createNetworkRequestActionSetWithSuppliedData } from '../networking/utils';
import { PapiDaSharedUserSendotp, PapiRequestDaSharedUserSendotp } from '@wix/da-papi-types';

export const {
  submit: sendOneTimePasswordRequest,
  success: sendOneTimePasswordRequestSuccess,
  failure: sendOneTimePasswordRequestFailure,
} = createNetworkRequestActionSetWithSuppliedData<
  PapiRequestDaSharedUserSendotp,
  PapiDaSharedUserSendotp
>(reduxKey, 'SEND_ONE_TIME_PASSWORD');
